import cn from "classnames";

import { brown } from "@/app/font";

import { SaleIcon } from "../icons/sale.icon";
import { Chip as ProductChip, Theme } from "@/sanity.types";

export const Chip = ({
  label,
  className,
  variant = "primary",
  chip,
}: ChipProps) => {
  return (
    <div
      className={cn(
        `${brown.className}`,
        "flex items-center gap-2 rounded-full px-2 py-1 text-sm leading-[1.3] whitespace-nowrap",
        {
          border: chip?.borderColor,
          "bg-secondary-100 text-white": variant === "primary",
          "text-secondary bg-white": variant === "secondary",
          "bg-greyscale-background text-success": variant === "success",
          "text-success border-success border bg-white": variant === "promo",
          "text-greyscale-body bg-white": variant === "white",
          "bg-greyscale-background text-greyscale-body": variant === "tertiary",
          "border-primary bg-primary-200 text-secondary border":
            variant === "recommended",
          "bg-primary white": variant === "light",
        },
        className,
      )}
      style={{
        backgroundColor: chip?.backgroundColor,
        color: chip?.textColor,
        borderColor: chip?.borderColor,
      }}
      data-testid="chip">
      {chip?.promo ? <SaleIcon width={14} /> : null}
      {label}
    </div>
  );
};

type ChipProps = {
  label?: string;
  className?: string;
  variant?: Theme;
  chip?: ProductChip;
};
